// src/firebase/config.js
import { initializeApp } from "firebase/app";

import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDjDBjEpYXv8KXlzLj2pFe8bNyBNX8ewqE",
  authDomain: "myharf-a6615.firebaseapp.com",
  projectId: "myharf-a6615",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize auth
const auth = getAuth(app);
// Set auth persistence
setPersistence(auth, browserLocalPersistence)
  .then(() => console.log("✅ Auth persistence enabled"))
  .catch((err) => console.warn("⚠️ Auth persistence error:", err));

export { app, auth };
